module.exports = __webpack_public_path__ + "static/media/recharging-your-battery-large@3x.cbc0cc4e.png";